import qs from 'qs';

const queryParams = (params: Record<string, string | undefined>) => qs.stringify(params);
export const createPath = (part: string | number, params?: Record<string, string | undefined>) => {
  let path = `/v4/admin/access/${part}`;

  if (params) {
    const query = queryParams(params);
    if (query) {
      path += `?${query}`;
    }
  }

  return path;
};
